import { Image, useMantineTheme, type ImageProps } from "@mantine/core";

import { APP_LOGO_HEIGHT, APP_LOGO_HEIGHT_MOBILE } from "@/configs/layout";
import { useEnv } from "@/hooks/useEnv";
import { useIsMobile } from "@/hooks/useIsMobile";
import { isDefined } from "@/utils/format";

interface AppLogoProps extends ImageProps {}
export const AppLogo = ({ h, ...props }: AppLogoProps) => {
  const { isMobile } = useIsMobile();
  const theme = useMantineTheme();
  const supabaseUrl = useEnv("VITE_SUPABASE_URL");
  const logo =
    isDefined(supabaseUrl) && isDefined(theme.other.logo) ? supabaseUrl + theme.other.logo : theme.other.logoLocal;

  const _height = h ?? (isMobile ? APP_LOGO_HEIGHT_MOBILE : APP_LOGO_HEIGHT);
  return <Image src={logo} h={_height} w="auto" p="sm" {...props} />;
};

export default AppLogo;
